import React from 'react'
import './DashBoard.css'

const DashBoard = () => {
    return (
        <div className='page-container'>
            <div className="dashboard">
                <header className="dashboard-header">
                    <h1>Admin Panel</h1>
                    <p>Welcome back, Admin 👋</p>
                </header>

                <section className="stats-grid">
                    <div className="stat-card">
                        <h2>1,245</h2>
                        <p>Active Users</p>
                    </div>
                    <div className="stat-card">
                        <h2>356</h2>
                        <p>New Posts</p>
                    </div>
                    <div className="stat-card">
                        <h2>87%</h2>
                        <p>Engagement Rate</p>
                    </div>
                    <div className="stat-card">
                        <h2>$12.4K</h2>
                        <p>Revenue</p>
                    </div>
                </section>

                <section className="charts-grid">
                    <div className="chart-card">
                        <h3>Monthly Users</h3>
                        <div className="chart-placeholder">📊 Chart</div>
                    </div>
                    <div className="chart-card">
                        <h3>Revenue Growth</h3>
                        <div className="chart-placeholder">📈 Chart</div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default DashBoard